import React, { useState } from "react";
import { useTheme } from "../contexts/ThemeContext";
import { useLang } from "../contexts/LanguageContext";
import AppLayout from "../components/AppLayout";
import BottomNav from "../components/BottomNav";
import { ArrowLeft, Send, Mail, MessageSquare } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ContactPage() {
  const { theme } = useTheme();
  const { lang } = useLang();
  const isDark = theme === "dark";
  const navigate = useNavigate();
  const [sent, setSent] = useState(false);
  const textPrimary = isDark ? "text-white" : "text-slate-900";
  const textBody = isDark ? "text-slate-300" : "text-slate-600";
  const labelColor = isDark ? "text-amber-400" : "text-amber-600";
  const inputBg = isDark ? "bg-slate-950/40 border-white/10 text-white placeholder:text-slate-500" : "bg-white/50 border-slate-200 text-slate-900 placeholder:text-slate-400";

  const titles = { fr: "Contact", en: "Contact", es: "Contacto", ar: "اتصل بنا" };

  return (
    <AppLayout>
      <div className="px-5 pt-12 pb-24 scrollbar-hide overflow-y-auto min-h-screen">
        <button onClick={() => navigate(-1)} className={`mb-4 p-2 rounded-full ${isDark ? "hover:bg-white/10" : "hover:bg-black/5"} transition-colors`}>
          <ArrowLeft size={20} className={textPrimary} />
        </button>
        <h1 className={`font-heading text-2xl font-bold ${textPrimary} mb-6`}>{titles[lang] || titles.fr}</h1>

        <div className="glass-card p-5 mb-5">
          <div className="flex items-center gap-3 mb-4">
            <Mail size={18} className={labelColor} />
            <p className={`text-sm font-semibold ${textPrimary}`}>Email</p>
          </div>
          <a href="mailto:contact@dreamnoor.com" className={`text-sm ${labelColor} underline`}>contact@dreamnoor.com</a>
          <p className={`text-xs ${textBody} mt-2`}>
            {lang === "ar" ? "نرد عادة خلال 24 ساعة" : lang === "es" ? "Respondemos en 24 horas" : lang === "en" ? "We typically respond within 24 hours" : "Nous répondons généralement sous 24 heures"}
          </p>
        </div>

        <div className="glass-card p-5 mb-5">
          <div className="flex items-center gap-3 mb-4">
            <MessageSquare size={18} className={labelColor} />
            <p className={`text-sm font-semibold ${textPrimary}`}>
              {lang === "ar" ? "أرسل رسالة" : lang === "es" ? "Enviar mensaje" : lang === "en" ? "Send a message" : "Envoyer un message"}
            </p>
          </div>

          {sent ? (
            <div className="text-center py-4">
              <p className={`text-sm ${isDark ? "text-emerald-400" : "text-emerald-600"} font-semibold`}>
                {lang === "ar" ? "تم الإرسال بنجاح!" : lang === "es" ? "¡Mensaje enviado!" : lang === "en" ? "Message sent!" : "Message envoyé !"}
              </p>
            </div>
          ) : (
            <form onSubmit={(e) => { e.preventDefault(); setSent(true); }} className="space-y-3">
              <input type="text" required placeholder={lang === "ar" ? "اسمك" : lang === "es" ? "Tu nombre" : lang === "en" ? "Your name" : "Votre nom"}
                className={`w-full border rounded-xl h-11 px-4 text-sm outline-none ${inputBg}`} />
              <input type="email" required placeholder={lang === "ar" ? "بريدك الإلكتروني" : lang === "es" ? "Tu correo" : lang === "en" ? "Your email" : "Votre email"}
                className={`w-full border rounded-xl h-11 px-4 text-sm outline-none ${inputBg}`} />
              <textarea required placeholder={lang === "ar" ? "رسالتك" : lang === "es" ? "Tu mensaje" : lang === "en" ? "Your message" : "Votre message"}
                className={`w-full border rounded-xl p-4 min-h-[100px] text-sm outline-none resize-none ${inputBg}`} />
              <button type="submit" className="w-full btn-gold py-2.5 text-sm font-semibold flex items-center justify-center gap-2">
                <Send size={14} /> {lang === "ar" ? "إرسال" : lang === "es" ? "Enviar" : lang === "en" ? "Send" : "Envoyer"}
              </button>
            </form>
          )}
        </div>

        <div className="glass-card p-5">
          <p className={`text-[10px] ${labelColor} uppercase tracking-[0.15em] font-semibold mb-3`}>DreamNoor</p>
          <p className={`text-sm ${textBody} leading-relaxed`}>
            DreamNoor est une application d'interprétation des rêves qui combine la sagesse islamique traditionnelle (ta'bir al-ru'ya) avec l'intelligence artificielle moderne. Notre mission est d'aider chacun à comprendre les messages de ses rêves dans un cadre spirituel et bienveillant.
          </p>
          <p className={`text-sm ${textBody} leading-relaxed mt-3`}>
            Site web : dreamnoor.com
          </p>
        </div>
      </div>
      <BottomNav />
    </AppLayout>
  );
}
